import { useSelector, shallowEqual } from 'react-redux';
import { useSearchParams } from 'react-router-dom';

import { POSTED_JOB_ID } from 'src/app/shared/constants/queryParams';
import type { AppState } from 'src/types/appState';

export const usePostedJobIdSelector = (): string | undefined => {
  const { flowType, jobId, sourceJobId } = useSelector(
    (state: AppState) => ({
      flowType: state.formData.flowType,
      jobId: state.session.job?.id,
      sourceJobId: state.session.sourceJobId,
    }),
    shallowEqual,
  );

  const [searchParams] = useSearchParams();

  const jobIdInQueryParam = searchParams.get(POSTED_JOB_ID) || '';

  if (flowType === 'edit') {
    return sourceJobId;
  }

  if (flowType === 'create') {
    return jobIdInQueryParam;
  }

  return jobId;
};
